import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { State } from 'redux/initialState';
import { EnvelopeWithStatus } from 'types/Envelope';

import { getEnvelopesById } from 'modules/_shared/redux/envelopeActions';
import { updateEnvelope } from 'modules/envelopes/redux/envelopeActions';

type EnvelopeResponse = EnvelopeWithStatus[];

export const useGetEnvelopeDetails = (envelopeId: string | undefined) => {
  const dispatch = useDispatch();

  const envelopes = useSelector((state: State) => state.envelopes);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const envelope = envelopes.find(
    (env) => env._id === envelopeId || env.envelopeId === envelopeId
  );

  const fetchEnvelopeDetails = useCallback(async () => {
    if (!envelopeId) {
      return;
    }

    try {
      setIsLoading(true);
      setError(null);

      const response = (await getEnvelopesById([
        envelopeId,
      ])) as EnvelopeResponse;

      if (response && response.length > 0) {
        const envelopeData = response[0];
        dispatch(updateEnvelope(envelopeData));
      } else {
        setError('Envelope not found');
      }
    } catch (err) {
      setError('Error loading envelope details');
      console.error('Error fetching envelope details:', err); // eslint-disable-line no-console
    } finally {
      setIsLoading(false);
    }
  }, [envelopeId, dispatch]);

  useEffect(() => {
    fetchEnvelopeDetails();
  }, [envelopeId]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    data: envelope,
    isLoading,
    error,
    actions: { refetch: fetchEnvelopeDetails },
  };
};
